import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { CustomInput, Row, Col, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { mdiMinusThick, mdiPlusThick } from '@mdi/js';
import Icon from '@mdi/react';
import { Checkbox } from 'cd-eft/components/common/Checkbox/Checkbox';
import './ProfileSettings.scss';
import { ProfileSettingsContainerVM } from './ProfileSettingsContainerVM';

interface ISubFormProps {
  profileSettingsForm;
  formValidation;
  toggleFineGrid;
  profileSettingsBankOnSelection?;
  handleCancelProfileSettings;
  handleSaveProfileSettings;
  previewProfileSettingsHandler?;
  title: string;
  saveButtonText: string;
  parentType: string;
  showVerticalInterval?;
}

export const ProfileSettingsContainer = observer((props: ISubFormProps) => {
  const {
    profileSettingsForm,
    formValidation,
    toggleFineGrid,
    profileSettingsBankOnSelection,
    handleCancelProfileSettings,
    handleSaveProfileSettings,
    previewProfileSettingsHandler,
    title,
    saveButtonText,
    parentType,
    showVerticalInterval
  } = props;

  const vmREF = useRef<ProfileSettingsContainerVM>();
  if (!vmREF.current) {
    vmREF.current = new ProfileSettingsContainerVM(props.parentType, props.formValidation, props.profileSettingsForm);
  }

  const vm = vmREF.current;

  return (
    <div className="profile-settings-container .modal-content eft-action-modal modal-Profile-Settings">
      <ModalHeader>
        <div className="display-flex flex-align-center">
          <strong>{title}</strong>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="h5 pt-3">
          <div className="fine-gird">
            <div>
              <Checkbox
                id="show-fine-grid"
                classAdmin="show-fine-grid"
                label="Show Fine Grid"
                checked={profileSettingsForm.checked.showFineGrid}
                name="show-fine-grid"
                onChange={toggleFineGrid}
              />
            </div>

            <div className="grid-counter">
              <button
                className="usa-button  usa-button--unstyled grid-counter-button"
                onClick={(e) => vm.handleSettingInputChange(e, 'minus')}
              >
                <Icon path={mdiMinusThick} size={1} />
              </button>
              <input
                className={
                  'usa-input grid-counter-input' + (formValidation['fineGridValid'] ? '' : ' usa-input--error')
                }
                id="fineGrid"
                value={profileSettingsForm.input.fineGrid}
                type="number"
                onChange={vm.handleSettingInputChange}
              ></input>
              <button
                className="usa-button usa-button--unstyled grid-counter-button"
                onClick={(e) => vm.handleSettingInputChange(e, 'plus')}
              >
                <Icon path={mdiPlusThick} size={1} />
              </button>
            </div>
          </div>
          {(parentType === "Terrace" || parentType === "UGO") && (
            <>
              <div className="profileSettingInputs">
                <label className={'usa-label profileSettingNumberInputLabel'} htmlFor="sampleInterval">
                  Sample Interval (ft)
                </label>
                <input
                  className={
                    'usa-input profileSettingNumberInput' +
                    (formValidation['sampleIntervalValid'] ? '' : ' usa-input--error')
                  }
                  id="sampleInterval"
                  value={profileSettingsForm.input.sampleInterval}
                  type="number"
                  onChange={vm.handleSettingInputChange}
                />
              </div>
              {showVerticalInterval && (
                <div className="profileSettingInputs">
                  <label className={'usa-label profileSettingNumberInputLabel'} htmlFor="verticalInterval">
                    Vertical Interval (ft)
                  </label>
                  <input
                    className={
                      'usa-input profileSettingNumberInput' +
                      (formValidation['verticalIntervalValid'] ? '' : ' usa-input--error')
                    }
                    id="verticalInterval"
                    value={profileSettingsForm.input.verticalInterval}
                    type="number"
                    onChange={vm.handleSettingInputChange}
                  />
                </div>
              )}
            </>
          )}
          {parentType === "Waterway" && (
            <>
              <Col>
                <Row>
                  <label className="usa-label lowBankProfile">Low Bank Profiles</label>
                </Row>

                <Row>
                  <div className="usa-radio mr-4">
                    <input
                      className="usa-radio__input"
                      type="radio"
                      id="showMergedLowBank"
                      name="showMergedLowBank"
                      checked={profileSettingsForm.showBankSelection === 'showMergedLowBank'}
                      onChange={profileSettingsBankOnSelection}
                    />
                    <label className="usa-radio__label" htmlFor="showMergedLowBank">
                      Show Merged Low Bank
                    </label>
                  </div>
                  <div className="usa-radio">
                    <input
                      className="usa-radio__input"
                      type="radio"
                      id="showLeftRightBanks"
                      name="showLeftRightBanks"
                      checked={profileSettingsForm.showBankSelection === 'showLeftRightBanks'}
                      onChange={profileSettingsBankOnSelection}
                    />
                    <label className="usa-radio__label" htmlFor="showLeftRightBanks">
                      Show Left/Right Banks
                    </label>
                  </div>
                </Row>
              </Col>
              <div className="profileSettingInputs margin-top">
                <label className={'usa-label profileSettingNumberInputLabel'} htmlFor="lowBankOffset">
                  Low Bank Offset (ft)
                </label>
                <input
                  className={
                    'usa-input profileSettingNumberInput' +
                    (formValidation['lowBankOffsetValid'] ? '' : ' usa-input--error')
                  }
                  id="lowBankOffset"
                  value={profileSettingsForm.input.lowBankOffset}
                  type="number"
                  onChange={vm.handleSettingInputChange}
                />
              </div>
              <div className="profileSettingInputs">
                <label className={'usa-label profileSettingNumberInputLabel'} htmlFor="sampleInterval">
                  Sample Interval (ft)
                </label>
                <input
                  className={
                    'usa-input profileSettingNumberInput' +
                    (formValidation['sampleIntervalValid'] ? '' : ' usa-input--error')
                  }
                  id="sampleInterval"
                  value={profileSettingsForm.input.sampleInterval}
                  type="number"
                  onChange={vm.handleSettingInputChange}
                />
              </div>
              <div className="profileSettingInputs">
                <label className={'usa-label profileSettingNumberInputLabel'} htmlFor="verticalInterval">
                  Vertical Interval (ft)
                </label>
                <input
                  className={
                    'usa-input profileSettingNumberInput' +
                    (formValidation['verticalIntervalValid'] ? '' : ' usa-input--error')
                  }
                  id="verticalInterval"
                  value={profileSettingsForm.input.verticalInterval}
                  type="number"
                  onChange={vm.handleSettingInputChange}
                />
              </div>
            </>
          )}
          {parentType === "Three Cross Sections" && (
            <>
              <div className="profileSettingInputs margin-top">
                <label className={'usa-label profileSettingNumberInputLabel'} htmlFor="bufferWidth">
                  Buffer Width (ft)
                </label>
                <input
                  className={
                    'usa-input profileSettingNumberInput' +
                    (formValidation['bufferWidthValid'] ? '' : ' usa-input--error')
                  }
                  id="bufferWidth"
                  value={profileSettingsForm.input.bufferWidth}
                  type="number"
                  onChange={vm.handleSettingInputChange}
                />
              </div>
              <CustomInput
                className='preview margin-top'
                type="switch"
                id="preview"
                data-testid="preview"
                name="preview"
                label="Preview"
                checked={profileSettingsForm.checked.previews}
                onChange={previewProfileSettingsHandler}
              />
            </>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="row justify-content-end mb-3">
          <button className="usa-button usa-button--outline" onClick={handleCancelProfileSettings}>
            Close
          </button>
          <button className="usa-button m-0" onClick={handleSaveProfileSettings} disabled={!formValidation.formValid}>
            {saveButtonText}
          </button>
        </div>
      </ModalFooter>
    </div>
  );
});
